<script lang="ts">
  import 'bootstrap/js/dist/modal';
  import { createEventDispatcher, onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr, isMobile } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { closeGiftPopupAfterGiftSelection } from '../services/pdp-data-services';
  import {
    giftPopupForCart,
    giftSelectedForCart,
    selectedGiftGroup,
    selectedGifts,
    shouldPDPGiftOptionReset,
  } from '../store/pdp_store';
  import AcPriceDiscountCard from './AcPriceDiscountCard.svelte';
  import FreeGiftProductCard from './FreeGiftProductCard.svelte';
  import ExtraUpgradeServiceMsg from './PDPExtraServices/ExtraUpgradeServiceMsg.svelte';
  const { pageTemplate } = getAppConfig();
  const mobile = isMobile();
  export let freeGiftDataList: Array<any>;
  export let isModel: boolean = true;
  export let preOrder: boolean = false;

  const dispatcher = createEventDispatcher();

  let optionSelected = [];
  let isModalOpenFirstTime = true;
  let isAddToCartButtonClicked = false;

  let selectedGiftsGroups = Array(freeGiftDataList.length).fill([]);
  let activeGroup = -1;

  $: isFixedDiscount =
    freeGiftDataList &&
    freeGiftDataList.length === 1 &&
    freeGiftDataList[0]?.freeGiftQtuantities?.sourceQty === freeGiftDataList[0]?.freeGiftQtuantities?.targetQty &&
    freeGiftDataList[0]?.acPriceDiscountValue &&
    freeGiftDataList[0]?.freeGiftProducts === null;

  $: isFixedGift =
    (freeGiftDataList &&
      freeGiftDataList.length === 1 &&
      freeGiftDataList[0]?.freeGiftQtuantities?.sourceQty === freeGiftDataList[0]?.freeGiftQtuantities?.targetQty &&
      !freeGiftDataList[0]?.acPriceDiscountValue) ||
    isFixedDiscount;

  $: isAcDiscountAvailable =
    freeGiftDataList &&
    freeGiftDataList.length &&
    freeGiftDataList[0]?.freeGiftQtuantities?.sourceQty === freeGiftDataList[0]?.freeGiftQtuantities?.targetQty &&
    freeGiftDataList[0]?.acPriceDiscountValue;

  $: isGiftSelectionInvalid =
    !selectedGiftsGroups ||
    activeGroup === -1 ||
    selectedGiftsGroups[activeGroup].length !== freeGiftDataList[activeGroup].freeGiftQtuantities.sourceQty;
  $: preorderGiftSelectionInvalid = !selectedGiftsGroups || activeGroup === -1;
  $: mobileSelectableGiftQty = freeGiftDataList?.[0]?.freeGiftQtuantities?.sourceQty || 0;
  $: mobileModalTitle =
    !isFixedGift && mobileSelectableGiftQty > 0
      ? getStr('extra.pdp.select.your.gifts.message', [mobileSelectableGiftQty])
      : '';

  const fixedGiftLabel = getStr('extra.pdp.gift.options.free.gifts').replace('|', '');

  function toggleMessageText(hide = true) {
    if (!isModel) {
      return false;
    }
    const selectedText = document.getElementById('selectedTextToggle');
    if (hide) {
      selectedText?.classList.add('hide');
    } else {
      selectedText?.classList.remove('hide');
    }
  }

  function clearGiftArray(currentIndex, data) {
    selectedGiftsGroups = selectedGiftsGroups.map((item, index) => (index === currentIndex ? item : []));
    if (
      data.gift.freeGiftQtuantities.sourceQty === 1 &&
      selectedGiftsGroups.some(inner => inner.length > 0) &&
      !selectedGiftsGroups.some(inner => inner.includes(data.e.target.value))
    ) {
      selectedGiftsGroups = selectedGiftsGroups.map(() => []);
    }
  }

  function updateGiftGroup() {
    if (preorderGiftSelectionInvalid) {
      // if the selection is invalid, clear the selectedGifts store
      selectedGifts.set([]);
      selectedGiftsGroups = selectedGiftsGroups.map(() => []);
      activeGroup = -1;
    } else {
      selectedGiftGroup.set(activeGroup);
      ///freeGiftSelection();
    }
  }

  function unselectPreviousSelection(giftSetCheckboxes, data) {
    [...giftSetCheckboxes].map(async (x: any) => {
      x.checked = false;
      optionSelected = [];
      if (x.value !== data.e.target.value) {
        handleCheckbox(x.value, data.index, 'uncheck');
      }
    });
    data.e.target.checked = true;
  }

  function handleClick(data) {
    data.e.target.value = data.e.target.value.replace(/~\d*$/, '');
    const giftSetCheckboxes = document?.querySelectorAll(
      `.js-cart-gift-set-container-${data.gift?.freeGiftRuleId} input[name="fgProductCodes"]`
    );
    if (data.e.target.checked) {
      if (data.gift === 'discount') {
        if (optionSelected.length) {
          data.e.target.checked = false;
          return;
        } else {
          optionSelected.push(data.e.target.value);
          toggleMessageText(false);
          return handleCheckbox(data.e.target.value, data.index, 'checked');
        }
      } else {
        if (
          selectedGiftsGroups[data.index].length === data.gift.freeGiftQtuantities.sourceQty &&
          data.gift.acPriceDiscountValue === null
        ) {
          if (isModel) {
            data.e.target.checked = false;
            return;
          } else {
            unselectPreviousSelection(giftSetCheckboxes, data);
          }
        }

        if (data.gift.freeGiftQtuantities.targetQty === data.gift.freeGiftQtuantities.sourceQty) {
          setTimeout(() => {
            giftSetCheckboxes.forEach((x: any) => {
              x.checked = true;
              if (x.value !== data.e.target.value) {
                optionSelected.push(x.value.replace(/~\d*$/, ''));
                return handleCheckbox(x.value, data.index, 'checked');
              }
            });
          }, 50);
        }
        toggleMessageText(false);
      }
      optionSelected.push(data.e.target.value);
    } else {
      if (data.gift === 'discount') {
        optionSelected = [];
        toggleMessageText(true);
        return handleCheckbox(data.e.target.value, data.index, 'uncheck');
      } else {
        if (data.gift.freeGiftQtuantities.targetQty === data.gift.freeGiftQtuantities.sourceQty) {
          setTimeout(() => {
            giftSetCheckboxes.forEach((x: any) => {
              x.checked = false;
              optionSelected = [];
              if (x.value !== data.e.target.value) {
                return handleCheckbox(x.value, data.index, 'uncheck');
              }
            });
          }, 50);
        }
        optionSelected = optionSelected.filter(item => item !== data.e.target.value);
        toggleMessageText(true);
      }
    }
    return handleCheckboxChanged(data);
  }
  function handleCheckboxChanged(data) {
    const event = data.e;
    const freeGiftDLIndex = data.index;
    if (event.target.checked) {
      // add the product to the corresponding group
      const addedProduct = event.target.value;
      selectedGiftsGroups[freeGiftDLIndex] = [...selectedGiftsGroups[freeGiftDLIndex], addedProduct];
      activeGroup = freeGiftDLIndex;

      if (!isModel) {
        clearGiftArray(freeGiftDLIndex, data);
        setTimeout(() => {
          updateGiftGroup();
        }, 1000);
      }
    } else {
      // remove the product from the selected group
      const removedProduct = event.target.value;
      selectedGiftsGroups[freeGiftDLIndex] = selectedGiftsGroups[freeGiftDLIndex].filter(x => x !== removedProduct);

      if (selectedGiftsGroups[freeGiftDLIndex].length === 0) {
        activeGroup = -1;
      }
    }

    console.log(selectedGiftsGroups, ' selectedGiftsGroups');
    return true;
  }

  function handleCheckbox(ele, freeGiftDLIndex, action) {
    if (action === 'checked') {
      // add the product to the corresponding group
      const addedProduct = ele === 'discount' ? ele : ele.replace(/~\d*$/, '');
      selectedGiftsGroups[freeGiftDLIndex] = [...selectedGiftsGroups[freeGiftDLIndex], addedProduct];
      activeGroup = freeGiftDLIndex;
    } else {
      // remove the product from the selected group
      const removedProduct = ele === 'discount' ? ele : ele.replace(/~\d*$/, '');
      selectedGiftsGroups[freeGiftDLIndex] = selectedGiftsGroups[freeGiftDLIndex].filter(x => x !== removedProduct);

      if (selectedGiftsGroups[freeGiftDLIndex].length === 0) {
        activeGroup = -1;
      }
    }
    return true;
  }

  function freeGiftSelection() {
    // if (isModel) {
    //   closeGiftPopupAfterGiftSelection(optionSelected);
    // } else {
    //   selectedGifts.set(optionSelected);
    // }
    closeGiftPopupAfterGiftSelection(optionSelected);
    if ($giftPopupForCart) {
      $giftSelectedForCart = true;
      dispatcher('giftSelectionForCart', {
        giftSelected: $selectedGifts,
        giftGroupIndex: activeGroup,
      });
      if (isModel) {
        if (typeof window['ACC']?.extragtm?.click?.freeGiftSelectionAction === 'function') {
          window['ACC'].extragtm.click.freeGiftSelectionAction($selectedGifts);
        }
      }
    }
  }
  function reset() {
    if (!isFixedGift) {
      activeGroup = -1;
      selectedGifts.set([]);
      optionSelected = [];
      selectedGiftsGroups = selectedGiftsGroups.map(() => []);
    } else {
      optionSelected = [...selectedGiftsGroups[0]];
      selectedGifts.set([...selectedGiftsGroups[0]]);
    }
  }

  onMount(() => {
    if (isFixedGift) {
      selectedGiftsGroups = Array(freeGiftDataList.length).fill([]);
      if (freeGiftDataList[0].acPriceDiscountValue && freeGiftDataList[0].freeGiftProducts === null) {
        $selectedGifts = ['discount'];
        selectedGiftsGroups[0] = ['discount'];
      } else {
        $selectedGifts = freeGiftDataList[0].freeGifts;
        selectedGiftsGroups[0] = freeGiftDataList[0].freeGifts;
      }
      activeGroup = 0;
      if (typeof window['ACC']?.extragtm?.click?.freeGiftSelectionAction === 'function') {
        window['ACC'].extragtm.click.freeGiftSelectionAction(freeGiftDataList[0].freeGifts);
      }
    } else if (isModalOpenFirstTime) {
      selectedGiftsGroups = Array(freeGiftDataList.length).fill([]);
      $selectedGifts = [];
    }
    isModalOpenFirstTime = false;
    const myModalEl = document.getElementById('giftModal');

    myModalEl?.addEventListener('hidden.bs.modal', function () {
      if (preOrder && isModel && pageTemplate != 'ProductDetailsPageTemplate') {
        const element = document.getElementById('giftModal');
        const modelClass = 'giftModalLabel modal fade';
        const modelClassWrapper = 'modal-dialog modal-lg modal-fullscreen-sm-down js-freegift-PDP-popup';
        const child1 = element.querySelector('#giftModalcontainer');
        const child2 = element.querySelector('#giftModalwrapper');

        element.classList.remove(...modelClass.split(' '));
        child1?.classList.remove(...modelClassWrapper.split(' '));
        child2?.classList.remove('modal-content');
        isModel = false;
      }
      if (isGiftSelectionInvalid) {
        // if the selection is invalid, clear the selectedGifts store
        selectedGifts.set([]);
        selectedGiftsGroups = selectedGiftsGroups.map(() => []);
        activeGroup = -1;
      } else {
        selectedGiftGroup.set(activeGroup);
        if ($giftPopupForCart && isAddToCartButtonClicked) {
          isAddToCartButtonClicked = false;
        }
        freeGiftSelection();
      }

      giftPopupForCart.set(false);
    });

    myModalEl?.addEventListener('shown.bs.modal', () => {
      if ($giftPopupForCart) {
        isModel = true;
      }
      if ($selectedGifts.length) {
        const giftCheckBox = document?.querySelectorAll(`.js-cart-gift-set-container input[name="fgProductCodes"]`);
        giftCheckBox.forEach((x: any) => {
          if (x.value === $selectedGifts[0]) {
            x.checked = true;
          }
        });
      }
      if ($shouldPDPGiftOptionReset) {
        shouldPDPGiftOptionReset.set(false);
        document.getElementById('selectedTextToggle')?.classList.add('hide');
        reset();
      }
    });
  });
  let modelClass = '',
    modelClass1 = '',
    modelClass2 = '';
  if (isModel) {
    modelClass = 'giftModalLabel modal fade';
    modelClass1 = 'modal-dialog modal-lg modal-fullscreen-sm-down js-freegift-PDP-popup';
    modelClass2 = 'modal-content';
  }
</script>

<div class={modelClass} class:mobile id="giftModal" tabindex="-1" aria-labelledby="giftModalLabel" aria-hidden="true">
  <div class={modelClass1} id="giftModalcontainer">
    <div class={modelClass2} id="giftModalwrapper">
      {#if isModel}
        <div class="modal-header">
          <div class="modal-title-wrap">
            <div class="gift-title-icon">
              <Icon glyph="gift" type="png" mobileSize={48} desktopSize={48} />
            </div>
            <div id="giftModalLabel" class="modal-title">
              {#if mobile && mobileModalTitle}
                {mobileModalTitle}
              {:else if isFixedGift}
                <Text key={fixedGiftLabel} />
              {:else}
                <Text key="extra.pdp.select.your.gift.message" />
              {/if}
            </div>
          </div>

          <svg
            class="gift-modal-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20C11.9778 20 13.9112 19.4135 15.5557 18.3147C17.2002 17.2159 18.4819 15.6541 19.2388 13.8268C19.9957 11.9996 20.1937 9.98891 19.8078 8.0491C19.422 6.10929 18.4696 4.32746 17.0711 2.92894C15.6725 1.53041 13.8907 0.578004 11.9509 0.192152C10.0111 -0.1937 8.00042 0.0043328 6.17316 0.761209C4.3459 1.51809 2.78412 2.79981 1.6853 4.4443C0.58649 6.08879 0 8.02219 0 10C0.00297449 12.6513 1.0575 15.1931 2.93222 17.0678C4.80694 18.9425 7.34875 19.997 10 20V20ZM10 0.952385C11.7894 0.952385 13.5387 1.48302 15.0266 2.47718C16.5145 3.47135 17.6741 4.88439 18.3589 6.53763C19.0437 8.19087 19.2229 10.01 18.8738 11.7651C18.5247 13.5202 17.663 15.1323 16.3976 16.3976C15.1323 17.663 13.5202 18.5247 11.7651 18.8738C10.01 19.2229 8.19086 19.0437 6.53762 18.3589C4.88439 17.6741 3.47134 16.5145 2.47718 15.0266C1.48301 13.5387 0.952381 11.7895 0.952381 10C0.955106 7.60126 1.90921 5.30155 3.60538 3.60538C5.30154 1.90921 7.60126 0.95511 10 0.952385V0.952385ZM6.80617 12.5205L9.32666 10L6.80617 7.47955C6.71943 7.38974 6.67143 7.26945 6.67252 7.14459C6.6736 7.01974 6.72368 6.9003 6.81197 6.81201C6.90026 6.72372 7.01969 6.67364 7.14455 6.67256C7.26941 6.67147 7.38969 6.71947 7.4795 6.80621L10 9.32667L12.5205 6.8062C12.6103 6.71946 12.7306 6.67146 12.8554 6.67255C12.9803 6.67363 13.0997 6.72371 13.188 6.812C13.2763 6.90029 13.3264 7.01973 13.3274 7.14458C13.3285 7.26944 13.2805 7.38973 13.1938 7.47954L10.6733 10L13.1938 12.5205C13.2393 12.5644 13.2756 12.6169 13.3005 12.675C13.3255 12.7331 13.3386 12.7956 13.3392 12.8588C13.3397 12.9221 13.3277 12.9848 13.3037 13.0433C13.2798 13.1018 13.2444 13.155 13.1997 13.1997C13.155 13.2444 13.1018 13.2798 13.0433 13.3037C12.9848 13.3277 12.9221 13.3397 12.8588 13.3392C12.7956 13.3386 12.7331 13.3255 12.675 13.3005C12.6169 13.2756 12.5644 13.2393 12.5205 13.1938L10 10.6733L7.47954 13.1938C7.38973 13.2806 7.26944 13.3286 7.14459 13.3275C7.01973 13.3264 6.9003 13.2763 6.81201 13.188C6.72372 13.0997 6.67364 12.9803 6.67255 12.8555C6.67147 12.7306 6.71947 12.6103 6.80621 12.5205L6.80617 12.5205Z"
              fill="#0065A4"
            />
          </svg>
        </div>
      {:else}
        <div class="c_gift-title">
          <Text key="extra.preorder.gifts.text" />
        </div>
      {/if}

      <div class="modal-body js-freegift-cart-popup">
        {#each freeGiftDataList as gift, index}
          {#if gift.freeGiftQtuantities.sourceQty !== gift.freeGiftQtuantities.targetQty}
            <div class="selection-container" class:hide={isModel}>
              <span>
                <Text
                  key="extra.pdp.select.your.gifts.message"
                  args={[`${gift.freeGiftQtuantities.sourceQty}`]}
                /></span
              >
            </div>
          {/if}

          {#if gift.freeGiftProducts !== null}
            <div
              data-selectedcount={selectedGiftsGroups[index].length}
              data-ruleid={gift.freeGiftRuleId}
              data-qty={gift.freeGiftQtuantities.sourceQty}
              class="gift-items-container js-freegift-cart js-item-count js-cart-gift-set-container js-cart-gift-set-container-{gift.freeGiftRuleId}"
              class:c_preorder-giftset={!isModel}
              class:c_preorder-nonset={gift.freeGiftQtuantities.sourceQty !== gift.freeGiftQtuantities.targetQty}
              class:c_preorder-gift-group={selectedGiftsGroups[index].length === gift.freeGiftQtuantities.targetQty}
            >
              <FreeGiftProductCard
                {isModel}
                {gift}
                {selectedGiftsGroups}
                {index}
                {isFixedGift}
                {selectedGifts}
                {activeGroup}
                on:handleGiftCheckbox={event => handleClick(event.detail)}
              />
            </div>
          {/if}
          {#if gift?.acPriceDiscountValue}
            {#if gift.freeGiftProducts !== null && isModel}
              <div class="other-option">
                <span>{getStr('extra.pdp.gift.options.or')}</span>
              </div>
            {/if}
            <div
              class="card-container js-free-gift-card-container"
              class:selected={selectedGiftsGroups[index].includes('discount')}
            >
              <AcPriceDiscountCard
                {gift}
                {selectedGiftsGroups}
                {index}
                {isFixedGift}
                {selectedGifts}
                {activeGroup}
                on:handleDiscountCheckbox={event => handleClick(event.detail)}
              />
            </div>
          {/if}
          {#if window['ACC']?.config?.productDetails?.upgradeDisclaimerText && isModel}
            <ExtraUpgradeServiceMsg serviceUpgradeText={window['ACC'].config.productDetails.upgradeDisclaimerText} />
          {/if}
          {#if index < freeGiftDataList.length - 1 && isModel}
            <div class="other-option">
              <span>{getStr('extra.pdp.gift.options.or')}</span>
            </div>
          {/if}
        {/each}
      </div>
      {#if freeGiftDataList[0].freeGiftQtuantities.sourceQty !== freeGiftDataList[0].freeGiftQtuantities.targetQty || freeGiftDataList.length > 1 || isAcDiscountAvailable}
        <div class="modal-footer">
          <!-- <PdpButton label={$_('pdp.selected')} type={'primary'} variant={'raised'}/> -->
          <button
            type="button"
            data-bs-dismiss="modal"
            id="login"
            aria-labelledby="login loginForm"
            disabled={isGiftSelectionInvalid}
            on:click={() => (isAddToCartButtonClicked = true)}
            class="c_button c_button--primary c_button--wide gift-select-cta"
          >
            <span>
              {$giftPopupForCart && !isAcDiscountAvailable
                ? getStr('extra.addtocartbutton')
                : getStr('extra.pdp.gift.options.select')}
            </span>
          </button>
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  :global(.giftModalLabel) {
    background: rgba(15, 23, 42, 0.4);
  }
  @include desktop-min-width {
    :global(.giftModalLabel .modal-dialog .modal-body) {
      flex: none;
    }
  }
  .gift-items-title {
    color: $neutral-dark-01;
    font-size: 18px;
    font-weight: 500;
    line-height: 16px;
    height: 43px;
    display: flex;
    align-items: end;
    @include desktop-max-width {
      font-size: 18px;
    }
  }
  .gift-items-container {
    margin-top: 14px;
    @include desktop-max-width {
      margin-top: 0px;
    }
  }
  .gift-items-title--color {
    color: $functional-orange;
  }
  .free-gift-set-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    margin: 0 0 16px;
  }
  :global(.giftModalLabel.show) {
    opacity: 1;
    padding: 0 !important;
  }
  .modal-dialog {
    margin: 0;
    margin-left: auto;
    height: 100%;
    @include desktop-min-width {
      max-width: 620px;
    }
  }

  .card-container :global {
    margin: 0 0 12px;
  }

  :global {
    .card-container {
      .mdc-card.mdc-card--outlined {
        border-radius: 8px;
      }
      &.selected {
        .mdc-card.mdc-card--outlined {
          border: 1px solid $icon-only-icon-blue;
        }
      }
    }
  }

  a {
    text-decoration: none;
    display: flex;
    .c_icon {
      transform: rotate(270deg);
      margin: 0 2px;
    }
  }

  .modal-option {
    p {
      padding: 0;
      margin: 0;
      color: $neutral-dark-01;
      @include desktop-min-width {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
  .modal-body {
    padding: 0;
  }
  .modal-content {
    border-radius: 20px 20px 0 0;
    height: 100%;
    overflow-y: scroll;
    padding: 0px;
    @include desktop-min-width {
      border-radius: 0;
      padding: 0px 17.5px;
    }
  }

  .modal-content::-webkit-scrollbar {
    display: none;
  }
  .modal-header {
    padding: 31px 0 7.5px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;

    .modal-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      color: $neutral-dark-01;

      @include desktop-min-width {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  .modal-title-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
    padding-top: 31px;
    @include desktop-max-width {
      padding-top: 0;
    }
  }

  .gift-modal-close {
    cursor: pointer;
    flex-shrink: 0;
  }
  .modal-footer :global {
    background: $primary-white;
    box-shadow: none;
    justify-content: flex-end;

    .mdc-button {
      width: 100%;
      height: 48px;
    }

    @include desktop-min-width {
      padding: 16px 0 28px;
      box-shadow: none;
    }
  }

  img {
    max-width: 64px;
  }

  .btn-close {
    margin: 0;
    background-size: 8px;
    border-radius: 50%;
    border: 1px solid $icon-only-icon-blue;
    padding: 0;
    // filter: invert(10%) sepia(87%) saturate(4257%) hue-rotate(238deg) brightness(94%) contrast(112%);
    height: 18px;
    width: 18px;
  }

  .other-option {
    text-align: center;
    padding-top: 25px;

    span {
      background: #e1edf4;
      border-radius: 20px;
      padding: 6px 10px;
      font-weight: 500;
      font-size: 11px;
      line-height: 14px;
      color: $neutral-dark-04;
    }
  }

  .selection-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 25px;
    span {
      font-weight: 500;
      font-size: 18px;
      line-height: 16px;
      color: $neutral-dark-01;
    }

    .selected-options {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: $neutral-dark-01;
      @include desktop-min-width {
        font-size: 1.6rem;
        line-height: 18px;
      }
    }
  }

  .oos-container {
    display: flex;
    justify-content: end;
  }
  .c_button--wide:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .gift-select-cta {
    width: fit-content;
    min-width: 140px;
    border-radius: 999px;
    margin-left: auto;
    @include desktop-min-width {
      height: 48px;
      font-size: 16px;
    }
  }

  @include desktop-max-width {
    .modal-content {
      border-radius: 24px 24px 0 0;
    }
    .modal-header {
      padding: 16px 16px 11px;
      align-items: center;
      border-bottom: 1px solid $secondary-gray-03;

      .modal-title {
        font-size: 14px;
        line-height: 16px;
        font-weight: 700;
      }
    }
    .modal-title-wrap {
      align-items: center;
      gap: 10px;
    }
    .gift-modal-close {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
    .modal-body {
      padding: 21px 16px;
      margin-top: 0;
    }
    .selection-container {
      display: none;
    }
    .other-option {
      padding-top: 20px;
    }
    .free-gift-set-heading {
      flex-direction: column;
      align-items: flex-start;
    }
    .gift-select-cta {
      width: 100%;
      min-width: 100%;
    }
  }
</style>
